;(function($){
    $(document).ready(function(){

        let html = $('html');
        let body = $('body');

        // is menu open?
        $('#header-container input').change(function() {
            if (this.checked) {
                body.addClass('menu-open');
            } else {
                setTimeout(() => {
                    body.removeClass('menu-open');
                }, 300);
            }
        });

        $('.clearable').each(function() {
            let self  = $(this);
            let input = self.find('input:text');
            let icon  = self.find('.clearable-clear');

            input.on('input', function(){
                icon.toggle(!!this.value);
            });

            icon.on('touchstart click', function(e) {
                e.preventDefault();
                input.val('').trigger('input');
            });
        });

        /**
         * Homepage
         */
        if (html.hasClass('page-home')) {
            $('#current-location').click(() => {

                let icon = $('<i class="ml-3 fa fa-spin fa-spinner"></i>');

                let self = $('#current-location');
                let container = self.parent();

                container.append(icon);

                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        function success(position) {

                            let geocoder = new google.maps.Geocoder();

                            let latlng = new google.maps.LatLng(
                                position.coords.latitude,
                                position.coords.longitude
                            );

                            geocoder.geocode({
                                'latLng': latlng
                            }, (results, status) => {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    CCMApp.startSubmission(results[0]);
                                }
                            });

                        }, function error() {
                            swal(
                                'Oops',
                                'Please enable location services and share your location',
                                'warning'
                            );
                            icon.remove();
                        }
                    );
                }
            });
        }

        /**
         * Thank You
         */
        if (html.hasClass('page-thank-you')) {
            let cta = $('#submit');

            cta.click(() => {
                let formContainer = $('#form-container');
                let formTitle     = $('#form-title');
                let name          = $('#name');
                let email         = $('#email');

                if (formContainer.validate()) {
                    cta.addClass('submitting');

                    $.post(
                        '/subscribe',
                        {
                            id: window.id,
                            name: name.val(),
                            email: email.val()
                        }
                    ).done(() => {
                        formContainer.slideUp('fast');
                        cta.addClass('d-none');
                        formTitle.html('Thank You!');

                        window.dataLayer = window.dataLayer || [];

                        window.dataLayer.push({
                            'event': 'user-subscribed'
                        });
                    });
                }
            });
        }

        /**
         * Contact
         */
        if (html.hasClass('page-contact')) {

            grecaptcha.ready(() => {
                grecaptcha.execute('6LeZ-J4UAAAAAA3qCwQPbTdrLwxd65xMhZ0q7SbJ', {action: 'contact'}).then(token => {
                    window.recaptchaToken = token;
                });
            });

            let cta = $('.cta');

            cta.click(() => {
                let form      = $('#contact-form');
                let formTitle = $('#form-title');

                let name     = form.find('[name="name"]');
                let email    = form.find('[name="email"]');
                let comments = form.find('[name="comments"]');

                if (form.validate()) {
                    cta.addClass('submitting');

                    $.post(
                        '/contact/submit',
                        {
                            name: name.val(),
                            email: email.val(),
                            comments: comments.val(),
                            recaptcha: window.recaptchaToken
                        }
                    ).done(() => {
                        form.slideUp('fast');
                        cta.addClass('d-none');
                        formTitle.html('Thank You!');

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({'event': 'get-in-touch'});
                    });
                }
            });
        }
    });
})(jQuery);